<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
		dataCy?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest}>
	<path
		d="M19.7071 14.293L12 6.58594L4.29289 14.293C3.90237 14.6836 3.90237 15.3167 4.29289 15.7073C4.68342 16.0978 5.31658 16.0978 5.70711 15.7073L12 9.41436L18.2929 15.7073C18.6834 16.0978 19.3166 16.0978 19.7071 15.7073C20.0976 15.3167 20.0976 14.6836 19.7071 14.293Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
